import React, { createRef, useEffect, useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';

import { Avatar } from 'uiToolkitV1/Avatar';
import { TextLabelSmall } from 'uiToolkitV1/Typography';

const ToggleItem = ({ Icon = null, src = null, selected = false, onClick, label }) => (
  <Box
    p={2}
    bg={selected ? 'surface.F5F7F9' : 'surface.white'}
    border="1px solid"
    borderColor={selected ? 'border.EBEFF3' : 'surface.white'}
    borderRight="0px"
    onClick={onClick}
    cursor="pointer"
    boxSizing="border-box"
    borderRadius="8px 0px 0px 8px"
  >
    {src && <Avatar src={src} size={24} />}
    {Icon && !src && <Icon boxSize="24px" color={selected ? 'surface.104F95' : 'surface.g2'} />}
    {!src && !Icon && label && (
      <Box
        borderLeftRadius="4px"
        bg="surface.F5F7F9"
        display="flex"
        justifyContent="center"
        alignItems="center"
        w="32px"
        h="32px"
      >
        <TextLabelSmall bold color="text.g2">
          {label}
        </TextLabelSmall>
      </Box>
    )}
  </Box>
);

const NavToggleItems = ({ options, value, onChange }) => {
  const [selectedValue, setSelectedValue] = useState(value);

  const onChangeHandler = (newSelectedValue) => {
    if (selectedValue === newSelectedValue) return;
    setSelectedValue(newSelectedValue);
    onChange && onChange(newSelectedValue);
  };

  useEffect(() => {
    if (value) {
      setSelectedValue(value);
    }
  }, [value]);

  return (
    <Flex
      borderRadius={8}
      display="inline-flex"
      flexDir="column"
      mt={2}
      bg="surface.white"
      overflowY="auto"
      flexShrink={0}
    >
      {options?.map(({ label, value, Icon = null, src = null }) => (
        <ToggleItem
          selected={selectedValue === value}
          key={value}
          onClick={() => onChangeHandler(value)}
          Icon={Icon}
          src={src}
          label={label}
        />
      ))}
    </Flex>
  );
};

const scrollToComponentTop = (ref, isUseStartScrollBlock) => {
  if (!ref) return;
  ref.current?.scrollIntoView({
    behavior: 'smooth',
    block: isUseStartScrollBlock ? 'start' : 'center',
  });
};

const ScrollableSectionNav = ({
  options = [],
  // selectedOptionLabel = options?.[0]?.label,
  children = null,
  maxH = null,
  isUseStartScrollBlock = false,
}) => {
  // const [selectedOptionValue, setSelectedOptionValue] = useState(selectedOptionLabel);
  const [selectedOptionValue, setSelectedOptionValue] = useState(options?.[0]?.label);
  const [navCompRefs, setNavCompRefs] = useState([]);
  // const [hasUserInteracted, setHasUserInteracted] = useState(false);

  const navItemOptions = options.map(({ label, ...rest }) => ({ value: label, label, ...rest }));

  useEffect(() => {
    setNavCompRefs((refs) => {
      const newRefs = [];
      options.forEach((_, index) => {
        newRefs[index] = refs[index] || createRef();
      });
      return newRefs;
    });
    if (options.length >= 1) {
      setSelectedOptionValue(options[0].label);
    }
  }, [options]);

  // useEffect(() => {
  //   if (!hasUserInteracted) {
  //     return;
  //   }
  //   const selectedOptionLabelIndex = options.findIndex(
  //     ({ label }) => label === selectedOptionLabel
  //   );
  //   scrollToComponentTop(navCompRefs?.[selectedOptionLabelIndex]);
  // }, [navCompRefs, options, selectedOptionLabel, hasUserInteracted]);

  const onChangeHandler = (newSelectedValue) => {
    setSelectedOptionValue(newSelectedValue);
    const selectedOptionLabelIndex = options.findIndex(({ label }) => label === newSelectedValue);
    scrollToComponentTop(navCompRefs?.[selectedOptionLabelIndex], isUseStartScrollBlock);
  };

  return (
    <Flex overflow="auto" flexGrow={1} maxH={maxH ?? '100%'} h="100%">
      <NavToggleItems options={navItemOptions} value={selectedOptionValue} onChange={onChangeHandler} />

      <Box
        overflowY="auto"
        flexGrow={1}
        borderRadius="0px 4px 4px 0px"
        border="1px solid #EBEFF3"
        borderLeft="0px"
        className="scrollableSection"
      >
        {React.Children.map(children, (child, index) => (
          <div ref={navCompRefs[index]}>{child}</div>
        ))}
      </Box>
    </Flex>
  );
};

export { ScrollableSectionNav };
